<template>
    <div v-if="!loading && !error">
        <search-profile :company="companyData" :user="companyUserData" :searchProfile="searchProfile" :metaData="{categories: categories, regions: regions}"></search-profile>
    </div>
    <div v-else-if="loading && !error">
        <loader class="c-m-loader--large"></loader>
    </div>
    <div v-else>
        <error-state></error-state>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import {IS_LOADING, GET_ERROR, GET_SEARCH_PROFILE} from '../../store/store-models/search-profile-model'
    import { GET_REGIONS, GET_CATEGORIES } from '../../store/store-models/filters-model';

    import SearchProfile from '../components/organisms/my-pages-sections/company/search-profile/OrganismMyPagesSearchProfile.vue';
    import Loader from '../components/molecules/MoleculeLoader.vue';
    import ErrorState from '../components/molecules/MoleculeErrorState.vue';

    export default {
        props: [
            'companyUserData',
            'companyData',
        ],
        components: {
            SearchProfile,
            Loader,
            ErrorState
        },
        computed: {
            ...mapGetters({
                loading: IS_LOADING,
                error: GET_ERROR,
                searchProfile: GET_SEARCH_PROFILE,
                regions: GET_REGIONS,
                categories: GET_CATEGORIES
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/my-pages-sublayouts/MyPagesSearchProfile.vue